window.google_maps_api_key = 'AIzaSyCMidVpQTnnKZFCbewz145XJqOZ8fOeGw8';

import App from './App.svelte';
import { Service } from "@API";
import component from "svelte-tag";

new component({component:App,tagname:"policy-loader",attributes:["program","broker"]})